import { createSlice } from "@reduxjs/toolkit"
import { status_slices } from "../Constants";

export const inventario = createSlice({
    name: 'inventario',
    initialState: {
        isLoading: true,
        status: status_slices.SUCCESS,
        productsIndicators: [],
        ordersIndicators: []
    },
    reducers: {

        clearProductsIndicators: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.WAITING;
            state.msg = '';
            state.productsIndicators = [];
        },
        clearOrdersIndicators: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.WAITING;
            state.msg = '';
            state.ordersIndicators = [];
        },
        setProductsIndicators: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.WAITING;
            state.msg = 'Indicadores cargados (Productos)';
            state.productsIndicators = action.payload.indicators;
        },
        setOrdersIndicators: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.WAITING;
            state.msg = 'Indicadores cargados (Ordenes)';
            state.ordersIndicators = action.payload.indicators;
        },
        // Reducers Estaticos
        processRequest: (state, action) => {
            state.isLoading = true;
            state.status = status_slices.PROCESSING;
        },
        notProcessRequest: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.WAITING;
        },
        setError: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.NOT_LOADED;
            state.msg = "";
        },
    }
});

export const { processRequest, notProcessRequest, setError, setOrdersIndicators, setProductsIndicators, clearOrdersIndicators, clearProductsIndicators } = inventario.actions;